import React from 'react';

function EmployeeContact({ contacts = [], setContacts }) {
  const contactTypes = ['Email', 'Phone', 'Address'];

  const handleContactChange = (index, field, value) => {
    const updated = [...contacts];
    updated[index][field] = value;
    setContacts(updated);
  };

  const addContact = () => {
    setContacts([
      ...contacts,
      {
        type: 'Email',
        value: '',
        startDate: '',
        endDate: '',
        priority: 1,
        additionalNotes: ''
      }
    ]);
  };

  const removeContact = (index) => {
    const updated = [...contacts];
    updated.splice(index, 1);
    setContacts(updated);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      {contacts.map((contact, index) => (
        <div key={index} style={{ position: 'relative', border: '1px solid #ccc', padding: '12px', borderRadius: '6px' }}>
          {/* Remove button */}
          <button
            type="button"
            onClick={() => removeContact(index)}
            style={{
              position: 'absolute',
              top: '6px',
              right: '6px',
              background: 'transparent',
              border: 'none',
              fontSize: '16px',
              cursor: 'pointer',
              color: '#dc3545'
            }}
            title="Remove Contact"
          >
            ✕
          </button>

          {/* Row 1: All form fields */}
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', marginBottom: '10px' }}>
            <label>
              Type:
              <select value={contact.type} onChange={(e) => handleContactChange(index, 'type', e.target.value)}>
                {contactTypes.map(t => <option key={t}>{t}</option>)}
              </select>
            </label>
            <label>
              Value:
              <input
                type="text"
                value={contact.value}
                onChange={(e) => handleContactChange(index, 'value', e.target.value)}
              />
            </label>
            <label>
              Start Date:
              <input
                type="date"
                value={contact.startDate}
                onChange={(e) => handleContactChange(index, 'startDate', e.target.value)}
              />
            </label>
            <label>
              End Date:
              <input
                type="date"
                value={contact.endDate}
                onChange={(e) => handleContactChange(index, 'endDate', e.target.value)}
              />
            </label>
            <label>
              Priority:
              <input
                type="number"
                min="1"
                value={contact.priority}
                onChange={(e) => handleContactChange(index, 'priority', e.target.value)}
              />
            </label>
          </div>

          {/* Row 2: Notes */}
          <label style={{ display: 'block' }}>
            Additional Notes:
            <textarea
              rows="2"
              style={{ width: '100%' }}
              value={contact.additionalNotes}
              onChange={(e) => handleContactChange(index, 'additionalNotes', e.target.value)}
            />
          </label>
        </div>
      ))}

      {/* Add Contact Button */}
      <button
        type="button"
        onClick={addContact}
        style={{
          background: '#007bff',
          color: 'white',
          border: 'none',
          padding: '8px 16px',
          borderRadius: '4px',
          alignSelf: 'flex-start'
        }}
      >
        + Add Contact
      </button>
    </div>
  );
}

export default EmployeeContact;
